export default {
  title: "Über uns",
  mission_vision: "Mission und Vision",
  mission_vision_desc:
    "Unsere Mission ist es, KMU dabei zu helfen, die EU-CBAM-Compliance schnell mit über 90 % Genauigkeit zu erreichen, Kosten zu senken und die Effizienz zu steigern und gleichzeitig die Nachhaltigkeitsziele für 2026 zu unterstützen.",
  team: "Team-Einführung",
  team_desc:
    "TaxEcoBit ist eine CBAM-Compliance-SaaS-Plattform, die von Fachleuten entwickelt wurde und sich darauf konzentriert, KMU effiziente und zuverlässige Tools zur Verfügung zu stellen, um Compliance-Prozesse zu vereinfachen und kontinuierlich zu aktualisieren, um den EU-Regularien zu entsprechen.",
  contact: "Kontaktieren Sie uns",
  contact_email: "E-Mail: {email}",
  follow_us: "Folgen Sie uns:",
  newsletter: "Newsletter",
  newsletter_desc:
    "Abonnieren Sie unseren Newsletter, um die neuesten CBAM-Richtlinieninterpretationen, Compliance-Tipps und Funktionsupdates zu erhalten.",
  newsletter_button: "Abonnieren",
  agreement_text:
    "Ich stimme zu, diese E-Mail zu verwenden, um die neuesten CBAM-Richtlinieninterpretationen, Compliance-Tipps und Funktionsupdates zu erhalten, und stimme der Verarbeitung meiner personenbezogenen Daten gemäß den GDPR-Anforderungen zu.",
  support: "Soforthilfe",
  support_desc:
    "Wir haben häufig gestellte Fragen für Ihre schnelle Selbstbedienungsanfrage zusammengestellt. Wenn Sie weitere Unterstützung benötigen, können Sie jederzeit ein Ticket einreichen, und unser Support-Team wird innerhalb von 24-48 Stunden antworten.",
  support_button: "Support kontaktieren",
  chat_opened: "Support-Fenster geöffnet",
  newsletter_success: "Abonnement erfolgreich: {email}",
};
